export default "__VITE_ASSET__Dbkvf$o2__"